import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Select from "util/component/SearchableSelect";

import axios from "util/axios";
import { useDispatch } from "react-redux";
import { Confirm2 } from "util/component/Modal2/Modal";

import update from "immutability-helper";

import cronstrue from "cronstrue";
import cronParser from "cron-parser";

import ModalPortal from "util/component/Modal";
import Cron from "./Cron";

const Circle = styled.button`
    flex: 0 0 20px;
    height: 20px;
    border: 2px solid;
    border-radius: 20px;
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    background-color: transparent;
    cursor: pointer;
    position: relative;
    ${(props) =>
        props.valid
            ? `
        border-color: var(--primary-color);
        color: var(--primary-color);
        &:hover .explain { display: block; }
        `
            : `
        border-color: var(--danger-color);
        color: var(--danger-color);
        
        `}
    & .explain {
        display: none;
        position: absolute;
        bottom: calc(100% + 10px);
        left: -50%;
        width: max-content;
        max-width: 300px;
        background-color: rgb(245, 245, 220);
        border: 1px solid #333;
        border-radius: 3px;
        z-index: 100;
        color: #333;
        padding: 3px;
    }

    & > .cron {
        display: none;
        position: absolute;
        top: -60px;
        left: calc(100% - 10px);
        width: max-content;
        background-color: rgb(245, 245, 220);
        border: 1px solid #333;
        border-radius: 3px;
        z-index: 100;
        color: #333;
        padding: 5px;
        margin-bottom: 100px;
        &.open { display: block }
    }
`;

const OPTIONS = [
    { value: 1, label: "Active" },
    { value: 0, label: "InActive" },
];

const Rows = (props) => {
    const { t } = useTranslation(["page"]);
    const { rowData: InitialRowData, index } = props;

    const [ConfirmOpen, SetConfirmOpen] = useState(false);
    const [ModalMsg, SetModalMsg] = useState(<p></p>);

    const dispatch = useDispatch();

    const [rowData, setRowData] = useState(InitialRowData);
    const [crontab, setCrontab] = useState(rowData.cronstr.toString().split(" "));

    const [cronExplain, setCronExplain] = useState();

    const [ cronOpen, setCronOpen ] = useState(false);

    const inputRefs = useRef([]);

    useEffect(() => {
        let debounce;

        debounce = setTimeout(() => {
            try {
                if (crontab.filter((f) => !f).length > 0) setCronExplain(null);
                else {
                    const cronstr = crontab.join(" ");
                    let parse = cronParser.parseExpression(cronstr);
                    setCronExplain(cronstrue.toString(cronstr));
                }
            } catch (e) {
                setCronExplain(null);
            }
            setRowData((OLD) => ({ ...OLD, cronstr: crontab.join(" ") }));
        }, 300);
        return () => clearTimeout(debounce);
    }, [crontab]);

    const Action = (type) => {
        if (type === "exe") {
            SetModalMsg(
                <Confirm2 onClose={() => SetConfirmOpen(false)} valid={() => true} onConfirm={() => execute()}>
                    <p>{t("executePrompt")}</p>
                </Confirm2>
            );
            SetConfirmOpen(true);
        } else if (type === "mod") {
            SetModalMsg(
                <Confirm2 onClose={() => SetConfirmOpen(false)} valid={() => true} onConfirm={() => modify()}>
                    <p>{t("saveConfirm")}</p>
                </Confirm2>
            );
            SetConfirmOpen(true);
        }
    };

    const execute = async (id) => {
        dispatch({ type: "LOADING_ON" });
        try {
            
            const response = await axios.post(process.env.REACT_APP_API + "/batch/exeBatch", rowData)
            	.then(Response => Response.data.data);
            window.location.reload();
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };
    const modify = async (id) => {
        dispatch({ type: "LOADING_ON" });
        try {
            
            const response = await axios.post(process.env.REACT_APP_API + "/batch/setBatch", rowData)
            	.then(Response => Response.data.data);
            window.location.reload()
        } catch (e) {
            console.error(e);
        } finally {
            dispatch({ type: "LOADING_OFF" });
        }
    };

    return (
        <>
            <tr>
                <td className={`text-center`}>{index + 1}</td>
                <td>{rowData.batchName}</td>
                <td>
                    <div className={`d-flex`}>
                        <div className={`d-flex flex-1`}>
                            {Array(6)
                                .fill()
                                .map((_, i) => {
                                    return (
                                        <input
                                            key={`${rowData.batchName}_cron${i}`}
                                            style={{
                                                flex: "0 0 50px",
                                                width: "50px",
                                                textAlign: "center",
                                                backgroundColor:
                                                    crontab[i] && !crontab[i].match(/[^0-9*?\-,/LW#A-Z]/) ? null : "#dc35456e",
                                            }}
                                            type="text"
                                            value={crontab[i]}
                                            onChange={({ target }) =>
                                                setCrontab((OLD) =>
                                                    update(OLD, {
                                                        [i]: { $set: target.value },
                                                    })
                                                )
                                            }
                                            ref={(ref) => (inputRefs.current[i] = ref)}
                                            tabIndex={i + 1}
                                            onKeyDown={(e) => {
                                                const { key } = e;
                                                const currentRef = inputRefs.current[i];
                                                if (key === "ArrowLeft" && currentRef.selectionStart === 0) {
                                                    // 현재 인풋 inputRefs.current[i] 의 커서위치가 0(처음) 이라면 이전 inputRefs로 이동
                                                    e.preventDefault();
                                                    inputRefs.current[i - 1]?.focus();
                                                } else if (
                                                    key === "ArrowRight" &&
                                                    currentRef.selectionStart === currentRef.value.length
                                                ) {
                                                    // 현재 인풋 inputRefs.current[i] 의 커서위치가 inputRefs.current[i].value.length(마지막) 이라면 다음 inputRefs로 이동
                                                    e.preventDefault();
                                                    inputRefs.current[i + 1]?.focus();
                                                }
                                            }}
                                        />
                                    );
                                })}
                        </div>
                        <Circle valid={!!cronExplain}  onMouseOver={(e) => {setCronOpen(true)}}>
                            {!!cronExplain ? "?" : "!"}
                            {!!cronExplain ? (
                                <div className={`explain`}>{cronExplain}</div>
                            ) : (
                                <div className={`cron ${cronOpen ? "open" : ""}`} onClick={() => setCronOpen(false)}>
                                    <Cron />
                                </div>
                            )}
                        </Circle>
                    </div>
                </td>
                <td>
                    <Select
                        value={rowData.active}
                        onChange={({ value }) => setRowData(OLD => ({...OLD, active: value}))}
                        options={OPTIONS}
                        search={false}
                    />
                </td>
                {/* <td><input type="text" value={v.batchData} onChange={({ target }) => change(i, target.value, 'batchData')} /></td> */}
                <td>{rowData.status}</td>
                <td>{rowData.startTime}</td>
                <td>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                        <button className={`bpl-btn primary`} onClick={() => Action("mod")} disabled={!cronExplain}>
                            {t("modify")}
                        </button>
                        <button className={`bpl-btn success`} onClick={() => Action("exe")}>
                            {t("execute")}
                        </button>
                    </div>
                </td>
            </tr>

            {ConfirmOpen && <ModalPortal>{ModalMsg}</ModalPortal>}
        </>
    );
};

export default Rows;
